module.exports = __webpack_public_path__ + "static/media/info-contrast.47d6edd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/info-contrast.svg
// module id = 633
// module chunks = 0